import { useEffect, useRef } from "react";

/**
 * Subscribe to task SSE stream. EventSource cannot send Authorization headers,
 * so the JWT is passed as a query param (same pattern as many SSE APIs).
 */
export function useTaskEvents({ apiUrl, getToken, onEvent, enabled = true }) {
    const onEventRef = useRef(onEvent);
    onEventRef.current = onEvent;

    useEffect(() => {
        if (!enabled || !apiUrl) return undefined;

        const token = getToken?.();
        if (!token) return undefined;

        const url = `${apiUrl}/task/events?token=${encodeURIComponent(token)}`;
        const es = new EventSource(url);

        es.onmessage = (event) => {
            try {
                const payload = JSON.parse(event.data);
                onEventRef.current?.(payload);
            } catch {
                /* ignore malformed payloads */
            }
        };

        es.onerror = () => {
            if (es.readyState === EventSource.CLOSED) {
                onEventRef.current?.({ type: "disconnected" });
            }
        };

        return () => es.close();
    }, [apiUrl, getToken, enabled]);
}

export default useTaskEvents;
